<template>
  <div>
    <v-dialog max-width="752px" v-model="methodDialog">
        <template v-slot:activator="{ on }">
            <div class="project__filter-outline"
                 v-ripple @click="methodDialog = true" >
                <div class="clients-list__item new-item">
                    <i class="material-icons new-item__icon">add</i>
                </div>
                <h2 class="new-item__title">Add a community</h2>
            </div>
        </template>
        <v-card class="dialog-card">
          <v-card-title>
            <h2 class="dialog-card__header">What type of community to add?</h2>
          </v-card-title>
          <v-form>
            <v-card-text>
              <v-radio-group>
                <v-banner class="form__item">
                  <span @click="selectMethod('existing')" class="radio-label">
                  </span>
                  <v-radio color="secondary" label="One or multiple existing communities"
                           value="ProjectSelectCommunities">
                  </v-radio>
                </v-banner>
                <v-banner class="form__item">
                  <span @click="selectMethod('new')" class="radio-label">
                  </span>
                  <v-radio color="secondary" label="A new community" value="ProjectAddCommunity">
                  </v-radio>
                </v-banner>
              </v-radio-group>
            </v-card-text>
          </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="addDialog" width="900">
      <v-card>
        <template v-if="method === 'new'">
          <NewCommunity
            @confirm="addNew"
            :with_namespace=false
          ></NewCommunity>
        </template>
        <template v-else>
          <v-card-text class="existing-communities">
            <SelectExisting :value="[]" :max="remaining" @input="addExisting">
            </SelectExisting>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import NewCommunity from "../../../Community/NewCommunity"
    import SelectExisting from "../../../Community/SelectExisting"
    import {store} from "../../../../store/store"
    import {keyToQuery, keyToQuery_, parens, names} from "../../../../_utils/communityNames"

    export default {
        name: "ProjectAddCommunity",
        props: ['projectid', 'selectedCommunities'],
        components: { NewCommunity, SelectExisting },
        data: () => ({
            addDialog: false,
            methodDialog: false,
            method: null
        }),
        computed: {
          remaining () {
            return 3 - store.state.project.configuration.communities.length
          }
        },
        methods: {
            selectMethod (m) {
                this.method = m
                this.methodDialog = false
                this.addDialog = true
            },
            addNew (community) {
                if (community) {
                    console.log("adding", community)
                    store.dispatch("addCommunityToProject",
                                   {projectId: store.state.project.id,
                                    community: {"label": community.name.name,
                                                "query": community.query,
                                                "is_temporary": true}})
                }
                this.addDialog = false
            },
            addExisting(selected) {
                console.log(selected)
                selected.forEach(c => {
                    console.log(c)
                    store.dispatch("addCommunityToProject",
                                   {projectId: store.state.project.id,
                                    community: {"label": c.key.name,
                                                "query": keyToQuery(c.key),
                                                "is_temporary": true}})
                })
                this.addDialog = false
            }
        },
        watch: {
            isDialogOpened: {
                handler: function (val) {
                    if (val !== undefined) {
                        this.dialog = eval(val);
                    }
                },
                deep: true
            },
            methodDialog (val, oldVal) {
                if (val) {
                    this.addDialog = false
                }
            }
        }
    }
</script>

<style scoped>

</style>
